import { apiClient } from "./apiClient";

const ENDPOINT = "/api/users/me";

export interface UpdateProfileDto {
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  ldapUsername?: string;
  gender?: string;
}

export interface ProfileResponse {
  id: string;
  firstName?: string;
  lastName?: string;
  points?: number;
  email?: string;
  phoneNumber?: string;
  ldapUsername?: string;
  title?: string;
  profilePhotoUrl?: string;
  isActive?: boolean;
  gender?: string;
  department?: {
    id: string;
    name: string;
  } | null;
  roles?: Array<{
    id: string;
    name: string;
  }>;
}

/**
 * PATCH /api/users/me - Update current user's profile
 */
export async function updateProfile(
  body: UpdateProfileDto
): Promise<ProfileResponse> {
  const { data } = await apiClient.patch<{ data?: ProfileResponse }>(
    ENDPOINT,
    body
  );
  return data?.data ?? (data as unknown as ProfileResponse);
}

/**
 * POST /api/users/me/profile-photo - Upload profile photo
 * Returns the new profile photo URL
 */
export async function uploadProfilePhoto(file: File): Promise<string> {
  const formData = new FormData();
  formData.append("file", file);

  const { data } = await apiClient.post<{ data?: { url?: string; profilePhotoUrl?: string } }>(
    `${ENDPOINT}/profile-photo`,
    formData
  );

  return data?.data?.url ?? data?.data?.profilePhotoUrl ?? "";
}

/**
 * DELETE /api/users/me/profile-photo - Remove profile photo
 */
export async function removeProfilePhoto(): Promise<void> {
  await apiClient.delete(`${ENDPOINT}/profile-photo`);
}
